import functions from '../functions';

$(() => {
    details.init();
})

const details = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    init() {

        details.$details = $('.page-type-details');

        if(! details.$details[0]) {
            return;
        }

    },
    getParams(params, defaults = {}) {
        return $.extend({}, params, defaults, functions.getUrlData(true));
    },
    isBookable(data) {
        return (data.booking.status == 'Request' || data.booking.status == 'Reservation') && data.isAvailable && data.calc.status == 'Active';
        //return data.booking.status == 'Request' || data.booking.status == 'Reservation';
    },
    isBookablePerService(services) {
        let isBookable = false;
        Object.entries(services).forEach(service => {
            const data = service[1];
            if ((data.booking.status === 'Request' || data.booking.status === 'Reservation') && data.calc.status === 'Active') {
                isBookable = true;
            }
        });
        return isBookable;
    },
    getMinPricePerService(services) {
        let min = null;
        Object.entries(services).forEach(service => {
            const data = service[1];
            if (min === null || +data.calc.total < min) {
                min = +data.calc.total;
            }
        });
        return min.toFixed(2);
    },
    getCalcErrorMessage(messages, data) {
        if(messages && data.calc && data.calc.message && data.calc.message.type) {
            return messages[data.calc.message.type] ? messages[data.calc.message.type].replace('{$condition}', (data.calc.message.condition_full ? data.calc.message.condition_full : data.calc.message.condition)) : null;
        }
        else if (data.message && messages && messages[data.message]) {
            return messages[data.message] ? messages[data.message].replace('{$condition}', data.condition) : null;
        }
        return messages ? messages.general : null;
    },
    getCalculation(params) {
        const objectGroupId = params.objectGroupId;
        const objectId = params.objectId;
        const unitId = params.unitId;
        const dateFrom = params.dateFrom;
        //const dateTo = params.dateTo ? params.dateTo : (params.objectGroupId !== 1 ? null : dateFrom);
        const dateTo = params.dateTo;
        const guests = params.guests && params.guests.startsWith('0') ? null : params.guests;
        const dynamicPackage = params.dynamicPackage;
        const pricelistId = params.pricelistId;
        const optionals = params.optionals;
        const serviceCode = params.serviceCode ? encodeURIComponent(params.serviceCode) : null;
        const aDateFrom = params.aDateFrom || null;
        const aDateTo = params.aDateTo || null;
        const transportUnitId = params.transportUnitId || null;
        const placeFromId = params.placeFromId || 0;
        const time = params.time || null;
        const calcPerService = params.calcPerService || 0;

        if(
            (objectId || unitId)
            && guests
            && dateFrom
            && dateTo
            && objectGroupId
        ) {
            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?publicId=' + objectId)
                + '&guests=' + guests
                + '&dateFrom=' + dateFrom
                + '&dateTo=' + dateTo
                + '&objectGroupId=' + objectGroupId
                + '&language=' + functions.getLang()
                + (dynamicPackage ? '&dynamicPackage=' + dynamicPackage : '')
                + (pricelistId ? '&pricelistId=' + pricelistId : '')
                + (optionals ? '&optionals=' + optionals : '')
                + (serviceCode ? '&serviceCode=' + serviceCode : '')
                + (aDateFrom ? '&aDateFrom=' + aDateFrom : '')
                + (aDateTo ? '&aDateTo=' + aDateTo : '')
                + (transportUnitId ? '&flightUnitId=' + transportUnitId : '')
                + (placeFromId ? '&placeFromId=' + placeFromId : '')
                + (time ? '&time=' + time : '')
                + (calcPerService ? '&calcPerService=1' : '')
                + '&addAllOptionals=true'
            );
        } else {
            return null;
        }

    },
    getCalcTotalOld(calcItems) {
        let priceOld = 0;

        calcItems.forEach(item => {
            // popust za djecu ne ulazi u prikaz discount cijene
            if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                priceOld += item.itemTotal;
            }
        });

        return priceOld;
    },
    getCalcDiscountTitle(calcItems) {

        let discountTitle = null

        calcItems.forEach(item => {
            if(item.itemType == 'discount') {
                discountTitle = item.itemTitle;
                if(item.data && item.data.text) {
                    discountTitle = item.data.text;
                }
            }
        });
        
        return discountTitle;
    },
    unitsSpinner() {

        $('.units-spinner').remove();
        let unitsSpinner = `<div class="units-spinner">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>`;
        $(unitsSpinner).insertBefore('.units')
        $('.units').removeClass('opacity-100');
        $('.units').addClass('opacity-0');

        setTimeout(() => {
            $('.units-spinner').remove();
            $('.units').addClass('opacity-100');
            $('.units').removeClass('opacity-0');
        }, 800);
    },
    /*loader($target = null) {
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);
    },*/
};

export {
    details,
};
